// react
import { useContext } from "react";

// context
import InitialContext from "../../context/InitialContext";

// components
import { Heading } from "../heading/Heading";
import Shelf from "../shelf/shelf.component";

// styles
import "./hero.styles.scss";

const Hero = () => {
  const context: any = useContext(InitialContext);

  const {
    initialState: {
      data: {
        Subheader,
        Headline,
        HeroImage: { Url },
      },
    },
  }: {
    initialState: {
      data: { Subheader: any; Headline: any; HeroImage: { Url: any } };
    };
  } = context;

  return (
    <>
      <div
        className={"_hero"}
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.333), rgba(0, 0, 0, 0.333)), url(${Url})`,
        }}
      >
        <Shelf mobile="10" tablet="15" desktop="15">
          <Heading className={"hdg invty_hero_hdg_h1 hdg_white"} element="h1">
            {Subheader}
          </Heading>
        </Shelf>
        <Shelf mobile="25" tablet="45" desktop="45">
          <Heading className={"hdg invty_hero_hdg_h2 hdg_white"} element="h2">
            {Headline}
          </Heading>
        </Shelf>
      </div>
    </>
  );
};

export default Hero;
